import Well from 'components/Well';
import styled from 'styled-components';

const ConfirmationWell = styled(Well)`
  font-size: 0.9em;
  height: 100%;

  p,
  span {
    font-size: 0.75em;
    margin-bottom: 0.5em;

    &:last-child {
      margin-bottom: 0;
    }
  }

  p span {
    font-size: 1em;
  }

  &.booking-confirmation {
    overflow-y: auto;
    overflow-x: hidden;

    .property {
      text-transform: capitalize;
    }

    h4 {
      margin-bottom: 0;
      font-size: 1.4em;
    }

    .row {
      p {
        margin-bottom: 0;
      }
    }

    h5 {
      color: #000;
      font-size: 1em;

      span {
        color: ${props => props.theme.table.headerColor};
        font-size: 1em;
      }
    }

    .row {
      margin-bottom: 0.5em;
    }

    p > span {
      padding-left: 0.5em;
      padding-right: 0.5em;

      &:first-child {
        padding-left: 0;
      }

      &:last-child {
        padding-right: 0;
      }
    }

    table {
      font-size: 0.8em;
      margin: 1em 0;

      tr {
        background-color: transparent;
      }

      td span {
        font-size: 1em;
        color: #000;
      }

      th {
        font-size: 1.4em;
        padding: 0 1.1em;
      }

      td {
        border: 0;
        padding: 0 1.5em;
        font-weight: bold;
      }
    }

    tr:last-child {
      h5 {
        font-size: 1em;
        margin: 0;
      }

      td:last-child span {
        font-size: 1em;
        color: #000;
      }

      td {
        border: 0;
      }

      td {
        color: #000;
      }
    }

    .print-header {
      display: none;
    }

    @media print {
      overflow-y: visible;
      height: auto;
      background: transparent;

      h4,
      h5 {
        font-size: 1em;
      }

      .print-header {
        display: block;
        text-align: center;
        margin-bottom: 1em;
      }

      button {
        display: none;
      }
    }
  }
`;

export default ConfirmationWell;
